
import {defineComponent, onMounted, ref} from 'vue';

const SCROLL_DELTA = 80;

export default defineComponent({
  setup() {
    let isHidden = ref(false);
    let isSticky = ref(false);

    let lastScrollPosition = window.pageYOffset;
    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= 0) {
        if (Math.abs(window.pageYOffset - lastScrollPosition) >= SCROLL_DELTA) {
          isHidden.value = window.pageYOffset >= lastScrollPosition;
          lastScrollPosition = window.pageYOffset;
        }
      }
      if (window.pageYOffset >= SCROLL_DELTA) {
        isSticky.value = true;
      } else {
        isSticky.value = false;
      }
    });

    onMounted(() => {
      const mainNavActive = document.querySelector('.main-nav-item.sub-1.active');
      const subNavLevel1Active = document.querySelector('.main-sub-nav-1-item.active');
      const page = document.querySelector('#page');
      const firstPageChild = page?.querySelector('section')
      const breadcrumbs = document.querySelector('.breadcrumb');

      if (firstPageChild?.classList.contains('ce-subpage-hero--dark') || firstPageChild?.classList.contains('ce-video-header--dark')) {
        breadcrumbs?.classList.add('breadcrumb--light');
      } else {
        breadcrumbs?.classList.remove('breadcrumb--light');
      }

      if (subNavLevel1Active || mainNavActive) {
        page?.classList.add('page--has-subpages');
      } else {
        page?.classList.remove('page--has-subpages');
      }

      const eventSubChildren = document.querySelector('.event-nav-2-item.active');
      if (eventSubChildren) {
        const eventMainNavActive = eventSubChildren.parentElement?.parentElement?.previousSibling;
        (eventMainNavActive as HTMLElement).classList.add('active')
      }
    });

    function toggleMobileNav() {
      let mobileNav = document.querySelector('.mobile-nav');
      let mobileLoginBtn = document.querySelector('.btn-login-mobile');
      let mobileSubNavLevel2 = document.querySelector('.main-sub-nav-2');
      let scrollPosition = window.scrollY;
      if (mobileNav) {
        document.body.classList.toggle('mobile-nav-opened');
        if (document.body.classList.contains('mobile-nav-opened')) {

          document.body.setAttribute('data-scroll', scrollPosition.toString());

          const activeNavItems: Array<HTMLElement> = [];
          Array.from<HTMLAnchorElement>(mobileNav.querySelectorAll('a.active')).forEach((link) => {
            const activeNavItem = link.parentElement;
            if (activeNavItem && activeNavItem.classList.contains('sub-1')) {
              activeNavItems.push(activeNavItem);
            }

            if (activeNavItem?.parentElement?.classList.contains('sub-2')) {
              const activeSubNavItemLevel1 = activeNavItem?.parentElement;
              const activeSubNavItemLevel2 = activeSubNavItemLevel1?.querySelector('.main-sub-nav-2-link.active');
              const mainSubNavLevel2 = activeSubNavItemLevel1?.getElementsByTagName('nav')[0];

              if (activeSubNavItemLevel2) {
                if (!mainSubNavLevel2!.classList.contains('event-collapse')) {
                  activeSubNavItemLevel1?.classList.add('sub-nav-2--shown');
                  activeSubNavItemLevel1?.classList.add('js-opened');
                  mainSubNavLevel2?.classList.add('show')
                }
              }
            }
          });

          activeNavItems.forEach((item) => {
            item.classList.add('js-opened');
            document.body.classList.add("main-sub-nav-opened");
          });
        } else {
          let scrollPosition = document.body.getAttribute('data-scroll');
          Array.from<HTMLAnchorElement>(mobileNav.querySelectorAll('.js-opened')).forEach((item) => {
            item.classList.remove('js-opened');
            document.body.classList.remove("main-sub-nav-opened");
          });
          document.body.setAttribute('data-scroll', '');
          window.scrollTo(0, Number(scrollPosition));
        }
      }
      if (document.body.classList.contains("mobile-login-nav-opened")) {
        document.body.classList.remove("mobile-login-nav-opened");
        mobileLoginBtn?.classList.remove('is-active')
      }
    };

    const toggleFirstSubNav = (event) => {
      const navItem = event.target ? (<HTMLInputElement>event.target).parentElement : null;
      if (navItem?.classList.contains('sub-1')) {
        navItem.classList.toggle('js-opened');
        document.body.classList.add("main-sub-nav-opened")
      }
    };

    const toggleMainNav = (event: Event, closeNav: boolean) => {
      const navItem = event.target ? (<HTMLInputElement>event.target).parentElement : null;
      if (navItem) {

        if (closeNav) {
          document.querySelector('.main-nav-item.js-opened')?.classList.remove('js-opened');
          document.body.classList.remove("main-sub-nav-opened");
        }
      }
      document.body.classList.remove("main-sub-nav-opened");
    };

    const toggleSecondSubNav = (event: Event) => {
      const navItem = event.target ? (<HTMLInputElement>event.target).parentElement?.parentElement : null;
      if (navItem?.classList.contains('sub-2')) {
        navItem.classList.toggle('js-opened');
        if (navItem?.classList.contains('sub-nav-2--shown')) {
          navItem.classList.remove('sub-nav-2--shown');
        }
      }
    };

    const toggleLoginMobileNav = (event: Event) => {
      let mobileNavLogin = document.querySelector('.mobile-nav-login');
      let mobileLoginBtn = document.querySelector('.btn-login-mobile');
      if (mobileNavLogin) {
        document.body.classList.toggle('mobile-login-nav-opened');
        if (document.body.classList.contains('mobile-login-nav-opened')) {
          mobileLoginBtn?.classList.add('is-active')
        } else {
          mobileLoginBtn?.classList.remove('is-active')
        }
      }
    };

    const toggleEventMobileNav = () => {
      let mobileEventNav = document.querySelector('.event-nav-mobile');
      const activeEventNavLevel2 = document.querySelector('.event-nav-2-link.active');
      if (mobileEventNav) {
        document.body.classList.toggle('mobile-event-nav-opened');
        if (activeEventNavLevel2) {
          const parent = activeEventNavLevel2.parentElement?.parentElement?.parentElement;
          parent?.classList.add('show')
        }
      }
    }


    return {
      isHidden, isSticky, toggleMobileNav, toggleFirstSubNav, toggleMainNav, toggleSecondSubNav, toggleLoginMobileNav, toggleEventMobileNav,
    };
  },
})
